import React, { useEffect, useState } from 'react'
import DateRange from '../../components/DateRange/DateRange';
import { useLocation } from 'react-router-dom';
import { useGlobalContext } from '../../Services/PaginationGlobal';
import { Table } from '../../components/Table/Table';
import { post } from '../../Services/ApiHandler';
import { URLS } from '../../Services/Constant';
import Topbar from '../../components/Topbar/Topbar';
import UserFailedTransaction from "./UserFailedTransaction";
import Select from "react-select";
import { ArrowBendUpLeft, cancel_icon } from "../../assets/img";

const tabs = ["Not Responded", "Responded"];

export default function TransactionsList() {
  const { paginationData, setpaginationData } = useGlobalContext();
  const location = useLocation();
  const path = location.pathname?.replace("/", "");
  const [count, setCount] = useState(0);
  const [activeTab, setActiveTab] = useState(
    paginationData?.[path]?.activeTab ?? "Not Responded", // ← reads the passed state
  );

console.log("active tab", activeTab, paginationData?.[path]?.activeTab );
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [transactions, setTransactions] = useState([]);
  const [pagination, setPagination] = useState({});
  //   const [selectedFilter, setSelectedFilter] = useState();

  const [activeGateway, setActiveGateway] = useState("Razor Pay");
  const [selectedFilter, setSelectedFilter] = useState({
    from: paginationData?.[path]?.from ?? "",
    to: paginationData?.[path]?.to ?? "",
    status: "",
    search: paginationData?.[path]?.search ?? "",
  });
  const gateways_pay = ["Razor Pay", "Cash Free"];
  const handleChangeFilter = (name, val) => {
    if (name !== "from" && val) setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  const columns = React.useMemo(() => [
    {
      Header: "S.No",
      accessor: "",
      Cell: ({ row }) => (
        <div style={{ alignItems: "center", display: "flex", gap: 5 }}>
          <p className="red">{row.index + 1 + (page - 1) * 10}</p>
        </div>
      ),
    },
    {
      Header: "Payment ID",
      accessor: "payment_id", // ✅ correct
      Cell: ({ value }) => (
        <div style={{ alignItems: "center", display: "flex", gap: 5 }}>
          <p>{value}</p>
        </div>
      ),
    },
    {
      Header: "Transaction ID",
      accessor: "order_id", // ✅ correct
      Cell: ({ value }) => (
        <div style={{ alignItems: "center", display: "flex", gap: 5 }}>
          <p>{value}</p>
        </div>
      ),
    },
    {
      Header: "User Name",
      accessor: "user_name", // ❌ was "name" → fixed to "user_name"
      Cell: ({ value }) => (
        <div style={{ alignItems: "center", display: "flex", gap: 5 }}>
          <p>{value}</p>
        </div>
      ),
    },
    {
      Header: "User ID",
      accessor: "user_code", // ✅ correct
      Cell: ({ value }) => (
        <div style={{ alignItems: "center", display: "flex", gap: 5 }}>
          <p>{value}</p>
        </div>
      ),
    },
    // {
    //   Header: "Bank RRN",
    //   accessor: "", // ❌ was "method" (not in data) → using "order_id" as closest match
    //   Cell: ({ value }) => (
    //     <div style={{ alignItems: "center", display: "flex", gap: 5 }}>
    //       <p>{value}</p>
    //     </div>
    //   ),
    // },
    {
      Header: "Customer details",
      accessor: "user_phone", // ❌ was "phone" → fixed to "user_phone"
      Cell: ({ value }) => (
        <div style={{ alignItems: "center", display: "flex", gap: 5 }}>
          <p>{value}</p>
        </div>
      ),
    },
    {
      Header: "Date",
      accessor: "created_at", // ❌ was "date_time" → fixed to "created_at"
      Cell: ({ value }) => (
        <div style={{ alignItems: "center", display: "flex", gap: 5 }}>
          <p>{value}</p>
        </div>
      ),
    },
    {
      Header: "Amount",
      accessor: "amount", // ✅ correct
      Cell: ({ value }) => (
        <div style={{ alignItems: "center", display: "flex", gap: 5 }}>
          <p>{value}</p>
        </div>
      ),
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ value }) => (
        <div
          style={{
            alignItems: "center",
            display: "flex",
            gap: 5,
            background: value === "failed" ? "#FF383C26" : "#FF8D2826",
            justifyContent: "center",
            borderRadius: 9,
            padding: "0 10px",
          }}
        >
          <div style={{ width: "17px", height: "33px" }}>
            <img
              src={value === "failed" ? cancel_icon : ArrowBendUpLeft}
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </div>
          <p
            style={{
              color: value === "failed" ? "#FF383C" : "#FF8D28",
              fontSize: 18,
              fontWeight: "500",
              margin: 0,
            }}
          >
            {value}
          </p>
        </div>
      ),
    },
  ]);

  const getList = async (pageNumber = 1) => {
    const { from, to } = selectedFilter;
    const payload = new FormData();

    if ((from && to) || (!from && !to)) {
      payload.append("from_date", from);
      payload.append("to_date", to);
    }
    payload.append(
      "gateway",
      activeGateway == "Razor Pay" ? "razorpay" : "cashfree",
    );
    if (selectedFilter?.status) {
      payload.append("status", selectedFilter?.status?.value);
    }
    const res = await post(
      `${URLS.PAYMENT_FAILED_TRANSACTION}?page=${pageNumber}`,
      payload,
    );
    console.log("mmc transactions list", res);
    if (res?.status === "success") {
      setCount(res?.count);
      setPagination({
        current_page: pageNumber,
        last_page: res?.total_pages,
      });
      setTransactions(res?.data);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  useEffect(() => {
    getList(page);

    setpaginationData((prev) => ({
      ...prev,
      [path]: { ...prev?.[path], page: page, activeTab: activeTab },
    }));
  }, [page, activeGateway, selectedFilter, activeTab]);
  console.log("selectedFilter", selectedFilter);

  return (
    <div>
      <Topbar header={"Payment Transaction"} />
      <div style={{ display: "flex", marginTop: 20, flexDirection: "row" }}>
        {tabs.map((tab, i) => (
          <>
            {i == 1 && (
              <span style={{ background: "#D1D1D6", width: 2 }}></span>
            )}
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              style={{
                padding: "10px 20px",
                borderRadius: "10px",
                fontSize: 14,
                color: activeTab === tab ? "#ffffff" : "#6b7280",
                background: activeTab === tab ? "#AE55F5" : "none",
                border: "none",
                outline: "none",
                marginLeft: i == 1 ? "10px" : i == 2 ? "10px" : "0px",
                marginRight: i == 1 ? "10px" : i == 0 ? "10px" : "0px",
              }}
            >
              {tab}
            </button>
          </>
        ))}
      </div>
      <UserFailedTransaction  activeTab={activeTab} selectedFilter={selectedFilter} setSelectedFilter={setSelectedFilter}/>
    </div>
  );
}
